import type React from 'react'

type Props = {
  className?: string
  size?: number
}

const IconSettings: React.FC<Props> = ({ size = 20, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.6562 13.3438C19.1133 13.3438 19.5 13.7305 19.5 14.1875C19.5 14.6797 19.1133 15.0312 18.6562 15.0312H6.98438C6.63281 16.1914 5.54297 17 4.3125 17C2.73047 17 1.5 15.7695 1.5 14.1875C1.5 12.6406 2.73047 11.375 4.3125 11.375C5.54297 11.375 6.63281 12.2188 6.98438 13.3438H18.6562ZM3.1875 14.1875C3.1875 14.8203 3.67969 15.3125 4.3125 15.3125C4.91016 15.3125 5.4375 14.8203 5.4375 14.1875C5.4375 13.5898 4.91016 13.0625 4.3125 13.0625C3.67969 13.0625 3.1875 13.5898 3.1875 14.1875ZM13.9805 5.46875C14.332 4.34375 15.4219 3.5 16.6875 3.5C18.2344 3.5 19.5 4.76562 19.5 6.3125C19.5 7.89453 18.2344 9.125 16.6875 9.125C15.4219 9.125 14.332 8.31641 13.9805 7.15625H2.34375C1.85156 7.15625 1.5 6.80469 1.5 6.3125C1.5 5.85547 1.85156 5.46875 2.34375 5.46875H13.9805ZM16.6875 7.4375C17.2852 7.4375 17.8125 6.94531 17.8125 6.3125C17.8125 5.71484 17.2852 5.1875 16.6875 5.1875C16.0547 5.1875 15.5625 5.71484 15.5625 6.3125C15.5625 6.94531 16.0547 7.4375 16.6875 7.4375Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconSettings
